import {Component, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import {
  FetchMyQuestionnairesListRequest
} from "../../core/questionnaires.actions";
import {fetchMyQuestionnairesList} from "../../core/questionnaires.selectors";
import {Subject, takeUntil} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {FormControl, FormGroup} from "@angular/forms";
import {CommonService} from "../../../../shared/services/common.service";
import {Sort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { sortOrderMap } from 'src/app/modules/shared/constants/common.constants';

@Component({
  selector: 'app-my-questionnaires-list-screen',
  templateUrl: './my-questionnaires-list-screen.component.html',
  styleUrls: ['./my-questionnaires-list-screen.component.css']
})
export class MyQuestionnairesListScreenComponent implements OnInit {
  expandPanel: any = true;
  loading: boolean = false
  surveyDisplayColumn: any[] = [
    'title',
    'description',
    'hasTakenSurvey',
    'view'
  ]
  currentPageNumber: number = 0;
  hasNext: boolean = false;
  hasPrevious: boolean = false
  isPaginationLoading: boolean = false
  filterForm: FormGroup = new FormGroup({
    searchText: new FormControl('')
  })
  sortColumn: any;
  sortOrder: any;
  isFirstPage: boolean = true;
  dataSource: any = new MatTableDataSource();
  sortOrderMap = sortOrderMap
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store,
    private router: Router,
    private commonService: CommonService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.store.dispatch(FetchMyQuestionnairesListRequest({payload: {pageNumber: 1}}))
    this.store.select(fetchMyQuestionnairesList).pipe(takeUntil(this.onDestroy))
      .subscribe(myQuestionnaires => {
          this.loading = myQuestionnaires.loading;
          this.hasNext = myQuestionnaires.hasNext;
          this.hasPrevious = myQuestionnaires.hasPrev;
          this.currentPageNumber = myQuestionnaires.pageNumber;
          if (myQuestionnaires.list.length > 0) {
            this.dataSource.data = myQuestionnaires.list;
          } else {
            this.dataSource.data = [];
          }

          if(!this.loading && this.sortColumn && this.currentPageNumber <= 2){
            this.commonService.scrollColumnInView(this.sortColumn)
          } 
          
          if (this.hasNext) {
            setTimeout(() => {
              // check window height for infinite scroll
              this.commonService.checkInfiniteScrollHeightAndCallNext('table-wrapper', () => {
                this.getNext();
              });
            }, 0)
          }
        }
      );
    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }

        const prevUrlParams = this.commonService.urlParams.getValue();
        
        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });
  }

  navigateToTakeSurvey(survey: any) {
    if (!survey.hasTakenSurvey) {
      const urlPrefix = this.router.url.split('/')[1];
      this.router.navigate([`/${urlPrefix}/questionnaires/take-questionnaires/${survey.id}`])
    } else if (survey.hasTakenSurvey) {
      const urlPrefix = this.router.url.split('/')[1];
      this.router.navigate([`/${urlPrefix}/questionnaires/survey-questionnaires/${survey.id}`])
    }
  }

  getNext() {
    this.isFirstPage = false;
    if (this.hasNext && !this.loading) {
      const sortOrder = this.getSortOrder();
      this.currentPageNumber = this.currentPageNumber + 1
      this.isPaginationLoading = true
      this.store.dispatch(FetchMyQuestionnairesListRequest({
        payload: {
          pageNumber: this.currentPageNumber,
          ...(this.filterForm.value.searchText ? {searchText: this.filterForm.value.searchText} : {}),
          ...(this.sortColumn && sortOrder ? {sortColumn: this.sortColumn} : {}),
          ...(this.sortColumn && sortOrder ? {sortOrder: sortOrder} : {})
        }
      }))
    }
  }

  applyButtonClicked() {
    this.isFirstPage = true;
    const sortOrder = this.getSortOrder();
    this.store.dispatch(FetchMyQuestionnairesListRequest({
      payload: {
        pageNumber: 1,
        ...(this.filterForm.value.searchText ? {searchText: this.filterForm.value.searchText} : {}),
        ...(this.sortColumn && sortOrder ? {sortColumn: this.sortColumn} : {}),
        ...(this.sortColumn && sortOrder ? {sortOrder: sortOrder} : {})
      }
    }));
  }

  sortData(sort: Sort) {
    this.isFirstPage = false;
    this.sortColumn = sort.active;
    this.sortOrder = sort.direction;
    const sortOrder = this.getSortOrder();
    this.store.dispatch(FetchMyQuestionnairesListRequest({
      payload: {
        pageNumber: 1,
        ...(this.filterForm.value.searchText ? {searchText: this.filterForm.value.searchText} : {}),
        ...(this.sortColumn && sortOrder ? {sortColumn: this.sortColumn} : {}),
        ...(this.sortColumn && sortOrder ? {sortOrder: sortOrder} : {})
      }
    }));
  }

  getSortOrder(): number {
    return this.sortOrderMap[this.sortOrder]
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
